<template>
  <!-- ヒーローセクションをスロットとして提供 -->
  <slot name="hero"></slot>

  <template v-if="shouldShowAnnouncements">
    <!-- お知らせエリア: メンテナンス情報があれば表示 -->
    <div v-if="maintenanceInfo && maintenanceInfo.isActive" class="announcement-wrapper">
      <MaintenanceAnnouncement
        :start-date="maintenanceInfo.startDate"
        :start-time="maintenanceInfo.startTime"
        :end-time="maintenanceInfo.endTime"
        :additional-info="maintenanceInfo.additionalInfo"
      />
    </div>

    <!-- 一般的なお知らせがあれば表示 -->
    <div v-if="announcements.length > 0" class="announcement-wrapper">
      <GeneralAnnouncement
        v-for="announcement in announcements"
        :id="announcement.id"
        :key="announcement.id"
        :title="announcement.title"
        :message="announcement.message"
        :additional-info="announcement.additionalInfo || ''"
      />
    </div>
  </template>

  <!-- メインコンテンツ -->
  <slot></slot>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
// メンテナンス情報表示用のコンポーネント
import MaintenanceAnnouncement from '@/components/common/Announcement/MaintenanceAnnouncement.vue';
// 一般的なお知らせコンポーネント
import GeneralAnnouncement from '@/components/common/Announcement/GeneralAnnouncement.vue';
// お知らせ情報取得用のサービス
import { getMaintenanceInfo, getVisibleAnnouncements } from '@/services/announcement.service';
// お知らせ情報の型定義
import type { MaintenanceInfo, AnnouncementInfo } from '@/services/announcement.service';

const route = useRoute();
const maintenanceInfo = ref<MaintenanceInfo | null>(null);
const announcements = ref<AnnouncementInfo[]>([]);

const shouldShowAnnouncements = computed(() => {
  return route.path === '/' || route.path === '/candidate/login';
});

onMounted(async () => {
  try {
    // メンテナンス情報を取得
    maintenanceInfo.value = await getMaintenanceInfo();

    // 表示すべきお知らせを取得
    announcements.value = await getVisibleAnnouncements();
  } catch (error) {
    console.error('お知らせ情報の取得に失敗しました', error);
  }
});
</script>

<style scoped>
.announcement-wrapper {
  width: 100%;
}
</style>
